export default {"src":"/_next/static/media/drop.08a877a4.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};